'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './workorder-ticket-edit.routes';

export class WorkOrderTicketEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, WorkOrderCodesService, WorkOrderTicketsService, PropertyService,
              VendorService, CommunityService, User, $uibModal, TemplateService) {
    'ngInject';

    this.ticketId = $stateParams.id;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.WorkOrderTicketsService = WorkOrderTicketsService;
    this.WorkOrderCodesService = WorkOrderCodesService;
    this.PropertyService = PropertyService;
    this.VendorService = VendorService;
    this.CommunityService = CommunityService;
    this.TemplateService = TemplateService;
    this.User = User;
    this.$stateParams = $stateParams;
    this.Auth = Auth;

    this.codes = [];
    this.codesEnum = [];
    this.schema = {};
    this.users = [];
    this.properties = [];
    this.vendors = [];

    this.TemplateService.query(data => {
      this.templates = data;
    });

    let resCount = 0;
    let maxResCount = 5;

    this.User.query(data => {
      this.users = data.map(user => {
        return {
          value: user._id,
          name: user.shortName || (user.firstName + ' ' + user.lastName)
        };
      });

      resCount++;
      if (resCount == maxResCount)
        this.fetchData();
    });

    this.WorkOrderCodesService.query(data => {
      this.codes = data;
      this.codesEnum = data.map(code => code.code);

      resCount++;
      if (resCount == maxResCount)
        this.fetchData();
    });

    this.VendorService.query(data => {
      this.vendors = data.map(vendor => {
        return {
          value: vendor._id,
          name: vendor.name,
          type: vendor.type
        };
      });

      resCount++;
      if (resCount == maxResCount)
        this.fetchData();
    });

    this.CommunityService.query(data => {
      this.communities = data.map(community => {
        return {
          value: community._id,
          name: community.code + ": " + community.name
        }
      });

      resCount++;
      if (resCount == maxResCount)
        this.fetchData();
    });

    this.PropertyService.query(data => {
      this.properties = data.map(property => {
        let address = "-";
        try {
          address = property.address.street + ', ' + property.address.city + ' ' + property.address.state + ', ' + property.address.zip;
        } catch(e){}

        return {
          value: property._id,
          name:  address + ' / ' + property.lotNo,
          community: property.community.name
        }
      });

      if (++resCount == maxResCount)
        this.fetchData();
    });

    this.jsonValue = "";
    this.$state = $state;

    this.model = {};
  }

  fetchData() {
    if (this.ticketId) {
      this.WorkOrderTicketsService.get({id: this.ticketId}, data => {
        this.model = data;

        if (this.model.targetDate)
          this.model.targetDate = new Date(this.model.targetDate);

        if (this.model.property)
          this.model.property = this.model.property._id;

        if (this.model.community)
          this.model.community = this.model.community._id;

        if (this.model.issuedTo)
          this.model.issuedTo = this.model.issuedTo._id;

        if (this.model.approvedBy)
          this.model.approvedBy = this.model.approvedBy._id;

      }, err => {
        console.log('Could not load work order ticket from server');
      })
    } else if (this.$stateParams.propertyId) {
      this.model.property = this.$stateParams.propertyId;
    } else if (this.$stateParams.communityId) {
      this.model.community = this.$stateParams.communityId;
    }

    this.activeTab = (this.model.community) ? 1 : 0;
  }

  templateLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'templateLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (template) {
        that.model.template = template._id;
      },
      function () { /* cancel */ }
    );

  }

  codeChanged () {
    let oCode = this.codes.find(code => code.code == this.model.code);

    if (!oCode)
      return;

    this.model.template = oCode.template;
    this.model.mailSubjectTemplate = oCode.mailSubjectTemplate;
    this.model.mailBodyTemplate = oCode.mailBodyTemplate;
    this.model.name = oCode.name;
    this.model.description = oCode.description;
    this.model.instructions = oCode.instructions;
  }

  openTargetDatePopup() {
    this.targetDatePopupOpened = true;
  }

  propertyLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'propertyLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (property) {
        that.selectedProperty = property;
        that.model.property = property._id;
      },
      function () { /* cancel */ }
    );

  }

  communityLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'communityLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (community) {
        that.model.community = community._id;
      },
      function () { /* cancel */ }
    );

  }

  userLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (user) {
        that.model.approvedBy = user._id;
      },
      function () { /* cancel */ }
    );

  }

  vendorLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'vendorLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (vendor) {
        that.selectedVendor = vendor;
        that.model.issuedTo = vendor._id;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.ticketId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The work order ticket has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("workorder-ticket-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.ticketId) {  // Save changes on the current settings
        this.WorkOrderTicketsService.update({id: this.ticketId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.WorkOrderTicketsService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.workOrderTicketEdit', [uiRouter])
  .config(routes)
  .component('workOrderTicketEdit', {
    template: require('./workorder-ticket-edit.html'),
    controller: WorkOrderTicketEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/workorders/ticket-edit/workorder-ticket-edit.component.js